import launch from "./launch";

const configRoutes = {
  launch: {
    routes: launch,
  },
};

export default configRoutes;
